export const currencyFields = [
  'budget',
  'bid',
  'budget_spent',
  'total_spent',
  'interval_spent',
  'interval_limit',
  'earned',
  'video_earned',
  'total_earned',
  'total_amount',
  'fraud_amount',
  'excluded_amount',
  'expired_amount',
  'acpa',
  'aepa',
  'acpc',
  'aepc',
  'acpv',
  'profits',
  'spend',
  'video_spend',
  'total_spend',
  'duplicate_amount',
  'billable_earned',
  'billable_spend',
];
